<template>
  <div class="file-upload-ctr">
    <div class="field-header">{{ fileUploadData.displayName }}</div>
    <div>
      <input
        type="file"
        id="files"
        ref="files"
        v-on:change="handleFilesUpload"
        :accept="fileUploadData.fileType"
        :data-vv-as="fileUploadData.displayName"
        :data-vv-name="fileUploadData.key"
        :key="fileUploadData.key"
        data-vv-validate-on="change"
        :error-messages="errors.collect(fileUploadData.key)"
      />
      <v-btn
        color="primary"
        outlined
        @click="selectFileToUpload"
        class="mr-2"
        height="32"
      >{{ fileUploadData.buttonLabel }}</v-btn>
      <span></span>
    </div>
    <div class="file-error" v-if="fileUploadData.showError">{{fileUploadData.errorMessage}}</div>
    <div class="file-list-cnr">
      <div class="file-list-item" v-if="fileUploadData.defaultValue">
        <span :title="fileUploadData.defaultValue">{{ fileUploadData.defaultValue }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      certFile: '',
      fileUploadData: this.fileUploadProps
    }
  },
  inject: ['$validator'],
  props: {
    fileUploadProps: Object
  },
  computed: {
    showError() {
      return this.fileUploadData.showError
    },
    showFontFormatError() {
      return this.fileUploadData.showFontFormatError
    }
  },
  methods: {
    selectFileToUpload() {
      console.log('button clicked', this)
      this.$refs.files.click()
    },
    handleFilesUpload(fileObj) {
      console.log('fileObj', fileObj)
      this.fileUploadData.showError = false
      this.fileUploadData.showFontFormatError = false
      this.fileUploadData.defaultValue = this.$refs.files.files[0].name
      // let uploadedFiles = this.$refs.files.files
      // this.$emit('on:custom', this.$refs.files.files[0])
    }
  }
}
</script>

<style>
input[type='file'] {
  /* position: absolute;
    top: -500px; */
  display: none;
}
.file-upload-ctr {
  margin-bottom: 24px;
}
div.file-listing {
  width: 200px;
}
span.file-count {
  font-size: 12px;
  vertical-align: bottom;
}
span.remove-file {
  color: red;
  cursor: pointer;
  float: right;
}
.file-error {
  color: #dc3828 !important;
  caret-color: #dc3828 !important;
  font-size: 12px;
  padding-left: 12px;
  margin-top: 4px;
}
.field-header {
  font-size: 15px;
  color: #666666;
  margin-bottom: 12px;
}
.file-disclaimer {
  font-size: 12px;
  line-height: 14px;
  color: #888888;
  margin-top: 8px;
}
.file-list-cnr {
  margin-top: 8px;
  margin-bottom: 16px;
}
.file-list-cnr .file-list-item {
  padding-left: 12px;
  text-align: left;
  height: 32px;
  margin-bottom: 4px;
  background-color: #f0f0f0;
  border-radius: 4px;
}
.file-list-cnr .file-list-item:last-child {
  margin-bottom: 36px;
}
.file-list-cnr .file-list-item > span {
  vertical-align: middle;
  /* width: 200px; */
  width: 70%;
  float: left;
  height: 32px;
  line-height: 32px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.file-list-cnr .file-list-item .v-btn__content i {
  font-size: 18px;
  color: #dc3828;
}
.file-list-cnr .file-list-item button {
  margin-left: 16px;
  float: right;
  height: 32px;
}
</style>
